require('../clipSearchService');
require('../../clipCategoryService');
require('../../dateService');
require('../../leaguesService');
require('../../teamService');
require('../clipFilterService');

angular.module('app.shared.clipSearch.filterFormDirective.filterFormController', [
  'app.shared.clipSearchService',
  'app.shared.clipCategoryService',
  'app.shared.dateService',
  'app.shared.leaguesService',
  'app.shared.teamService',
  'app.shared.clipSearch.clipFilterService'
])
  .controller('app.shared.clipSearch.filterFormDirective.filterFormController', [
    '$scope',
    'app.shared.clipSearchService',
    'app.shared.clipCategoryService',
    'app.shared.dateService',
    'app.shared.leaguesService',
    'app.shared.teamService',
    '$q',
    'app.shared.clipSearch.clipFilterService',
    '$filter',
    '$rootScope',
    function ($scope,
              clipSearchService,
              clipCategoryService,
              dateService,
              leaguesService,
              teamService,
              $q,
              clipFilterService,
              $filter,
              $rootScope) {
      "use strict";

      if (!$scope.filterData) {
        $scope.filterData = {
          filters: {},
          labels: {},
          preset: null
        };
      }
      $scope.showPresetActions = $scope.showPresetActions ? $scope.showPresetActions : null;
      $scope.defaultValue = $scope.defaultValue ? $scope.defaultValue : false;
      $scope.presetFilters = null;
      $scope.selectedPreset = null;
      $scope.categories = null;
      $scope.subcategories = null;
      $scope.strengths = null;
      $scope.seasons = null;
      $scope.leagues = null;
      $scope.opponentTeams = null;
      $scope.opponents = null;
      $scope.playerTeams = null;
      $scope.players = null;
      $scope.opponentPlayers = null;
      $scope.presetName = null;
      $scope.showPresetForm = false;
      $scope.deleteSelectedPreset = false;
      $scope.assignPresetFilters = true;
      $scope.filterCount = 0;
      $scope.clipCount = 0;
      $scope.disableSelections = false;

      $scope.getFilterTypeId = (type) => {
        switch (type) {
          case 'players':
            return 'id';
          case 'teams' :
            return 'iteamid';
          case 'categories' :
            return 'iclipcategoryid';
          case 'seasons' :
            return 'id';
          case 'subcategories' :
            return 'id';
          case 'strengths' :
            return 'id';
          default:
            return 'id';
        }
      };

      $scope.customDataDisplay = (type, datum) => {
        switch(type) {
          case 'player':
            return '#'+datum.jersey_number+' - '+datum.team_abbrev+' - '+datum.label+' ('+datum.season+')';
          case 'preset':
            return 'QUICK FILTER: ' + datum.name;
          case 'season':
            return datum.year + ' Season';
        }
      };

      $scope.getSelectedFilters = (filterArray, selectedIdsArray, type_id, is_grouped) => {
        let ObjArray = [];

        if(!filterArray || !angular.isDefined(selectedIdsArray)) {
          return ObjArray;
        }

        if(is_grouped) {
          let temp = [];
          _.forEach(filterArray, (array) => {
            _.forEach(array, (object) => {
              temp.push(object);
            });
          });

          filterArray = temp;
        }

        _.forEach(selectedIdsArray, (id) => {
          let selectedObj = filterArray.find((obj) => {
            return obj[type_id] === id;
          });

          if(selectedObj) {
            ObjArray.push(selectedObj);
          }
        });

        return ObjArray;
      };

      $scope.setFilterProperty = (name, value) => {
        switch (name) {
          case 'preset':
            $scope.selectedPreset = angular.copy(value);
            break;
          case 'date':
            $scope.filterData.filters.start_date = null;
            $scope.filterData.filters.end_date = null;
            delete $scope.filterData.labels['date-1'];
            break;
          case 'start_date':
          case 'end_date':
            $scope.filterData.filters[name] = value;
            break;
          case 'seasons':
            if (value === 'clear') {
              $scope.filterData.filters.seasons = [];

              for (let i in $scope.filterData.labels) {
                if ($scope.filterData.labels.hasOwnProperty(i)) {
                  if (i.match(/^seasons-/)) {
                    delete $scope.filterData.labels[i];
                  }
                }
              }

            } else {
              let season_id = value.id;
              let label = $scope.customDataDisplay('season', value);

              if (!Array.isArray($scope.filterData.filters.seasons)) {
                $scope.filterData.filters.seasons = [];
              }

              let season_index = $scope.filterData.filters.seasons.indexOf(season_id);
              if (season_index > -1) {
                $scope.filterData.filters.seasons.splice(season_index, 1);
                delete $scope.filterData.labels[`seasons-${season_id}`];
              } else {
                $scope.filterData.filters.seasons.push(season_id);
                $scope.filterData.labels[`seasons-${season_id}`] = label;
              }
            }
            break;
          case 'players':
            if (value === 'clear') {
              $scope.filterData.filters.players = [];

              for (let i in $scope.filterData.labels) {
                if ($scope.filterData.labels.hasOwnProperty(i)) {
                  if (i.match(/^players-/)) {
                    delete $scope.filterData.labels[i];
                  }
                }
              }
            } else {
              let player_id = value.id;
              let label = $scope.customDataDisplay('player', value);

              if (!Array.isArray($scope.filterData.filters.players)) {
                $scope.filterData.filters.players = [];
              }

              let player_index = $scope.filterData.filters.players.indexOf(player_id);
              if (player_index > -1) {
                $scope.filterData.filters.players.splice(player_index, 1);
                delete $scope.filterData.labels[`players-${player_id}`];
              } else {
                $scope.filterData.filters.players.push(player_id);
                $scope.filterData.labels[`players-${player_id}`] = label;
              }
            }
            break;

          case 'opponent_players':
            let player_found = false;
            if (value === 'clear') {
              $scope.filterData.filters.opponent_players = [];
              $scope.filterData.filters.opponent_player_teams = [];

              for (let i in $scope.filterData.labels) {
                if ($scope.filterData.labels.hasOwnProperty(i)) {
                  if (i.match(/^opponent_players-/)) {
                    delete $scope.filterData.labels[i];
                  }
                }
              }
            } else {
              let player_id = value.id;
              let label = $scope.customDataDisplay('player', value);
              let team_id = value.team_id;

              if (!Array.isArray($scope.filterData.filters.opponent_players)) {
                $scope.filterData.filters.opponent_players = [];
                $scope.filterData.filters.opponent_player_teams = [];
              }

              let team_index = $scope.filterData.filters.opponent_player_teams.indexOf(team_id);

              let player_index = $scope.filterData.filters.opponent_players.indexOf(player_id);
              if (player_index > -1) {
                $scope.filterData.filters.opponent_players.splice(player_index, 1);
                delete $scope.filterData.labels[`opponent_players-${player_id}`];

                let players = $filter('filter')($scope.opponentPlayers.list, {team_id: team_id});

                _.forEach( $scope.filterData.filters.opponent_players, (player_id) => {
                    _.forEach(players, (player) => {
                        if(player.id === player_id) {
                          player_found = true;
                        }
                    });
                });

                if(!player_found) {
                  $scope.filterData.filters.opponent_player_teams.splice(team_index, 1);
                }

              } else {
                $scope.filterData.filters.opponent_players.push(player_id);
                $scope.filterData.labels[`opponent_players-${player_id}`] = label;

                if(team_index === -1) {
                  $scope.filterData.filters.opponent_player_teams.push(team_id);
                }
              }

            }
            break;
          case 'categories':
            if (value === 'clear') {
              $scope.filterData.filters.categories = [];
              for (let i in $scope.filterData.labels) {
                if ($scope.filterData.labels.hasOwnProperty(i)) {
                  if (i.match(/^categories-/)) {
                    delete $scope.filterData.labels[i];
                  }
                }
              }
            } else {
              let category_id = value.iclipcategoryid;
              let label = value.strclipcategory;

              if (!Array.isArray($scope.filterData.filters.categories)) {
                $scope.filterData.filters.categories = [];
              }

              let category_index = $scope.filterData.filters.categories.indexOf(category_id);
              if (category_index > -1) {
                $scope.filterData.filters.categories.splice(category_index, 1);
                delete $scope.filterData.labels[`categories-${category_id}`];
              } else {
                $scope.filterData.filters.categories.push(category_id);
                $scope.filterData.labels[`categories-${category_id}`] = label;
              }
            }
            break;

          case 'subcategories':
            if (value === 'clear') {
              $scope.filterData.filters.subcategories = [];
              for (let i in $scope.filterData.labels) {
                if ($scope.filterData.labels.hasOwnProperty(i)) {
                  if (i.match(/^subcategories-/)) {
                    delete $scope.filterData.labels[i];
                  }
                }
              }
            } else {
              let subcategory_id = value.id;
              let label = value.subcategory;

              if (!Array.isArray($scope.filterData.filters.subcategories)) {
                $scope.filterData.filters.subcategories = [];
              }

              let subcategory_index = $scope.filterData.filters.subcategories.indexOf(subcategory_id);
              if (subcategory_index > -1) {
                $scope.filterData.filters.subcategories.splice(subcategory_index, 1);
                delete $scope.filterData.labels[`subcategories-${subcategory_id}`];
              } else {
                $scope.filterData.filters.subcategories.push(subcategory_id);
                $scope.filterData.labels[`subcategories-${subcategory_id}`] = label;
              }
            }
            break;

          case 'strengths':
            if (value === 'clear') {
              $scope.filterData.filters.strengths = [];
              for (let i in $scope.filterData.labels) {
                if ($scope.filterData.labels.hasOwnProperty(i)) {
                  if (i.match(/^strengths-/)) {
                    delete $scope.filterData.labels[i];
                  }
                }
              }
            } else {
              let strength_id = value.id;
              let label = value.strength;

              if (!Array.isArray($scope.filterData.filters.strengths)) {
                $scope.filterData.filters.strengths = [];
              }

              let strength_index = $scope.filterData.filters.strengths.indexOf(strength_id);
              if (strength_index > -1) {
                $scope.filterData.filters.strengths.splice(strength_index, 1);
                delete $scope.filterData.labels[`strengths-${strength_id}`];
              } else {
                $scope.filterData.filters.strengths.push(strength_id);
                $scope.filterData.labels[`strengths-${strength_id}`] = label;
              }
            }
            break;
          case 'opponent_teams':
            if (value === 'clear') {
              $scope.filterData.filters.opponents = [];

              for (let i in $scope.filterData.labels) {
                if ($scope.filterData.labels.hasOwnProperty(i)) {
                  if (i.match(/^opponents-/)) {
                    delete $scope.filterData.labels[i];
                  }
                }
              }
            } else {
              let opponent_id = value.iteamid;
              let label = value.label;

              if (!Array.isArray($scope.filterData.filters.opponents)) {
                $scope.filterData.filters.opponents = [];
              }

              let opponent_index = $scope.filterData.filters.opponents.indexOf(opponent_id);
              if (opponent_index > -1) {
                $scope.filterData.filters.opponents.splice(opponent_index, 1);
                delete $scope.filterData.labels[`opponents-${opponent_id}`];
              } else {
                $scope.filterData.filters.opponents.push(opponent_id);
                $scope.filterData.labels[`opponents-${opponent_id}`] = label;
              }
            }
            break;

          case 'my_teams':
            if (value === 'clear') {
              $scope.filterData.filters.my_teams = [];

              for (let i in $scope.filterData.labels) {
                if ($scope.filterData.labels.hasOwnProperty(i)) {
                  if (i.match(/^my_teams-/)) {
                    delete $scope.filterData.labels[i];
                  }
                }
              }
            } else {
              let my_team_id = value.iteamid;
              let label = value.label;

              if (!Array.isArray($scope.filterData.filters.my_teams)) {
                $scope.filterData.filters.my_teams = [];
              }

              let my_team_index = $scope.filterData.filters.my_teams.indexOf(my_team_id);
              if (my_team_index > -1) {
                $scope.filterData.filters.my_teams.splice(my_team_index, 1);
                delete $scope.filterData.labels[`my_teams-${my_team_id}`];
              } else {
                $scope.filterData.filters.my_teams.push(my_team_id);
                $scope.filterData.labels[`my_teams-${my_team_id}`] = label;
              }
            }
            break;
        }

        switch (name) {
          case 'start_date':
          case 'end_date':
            let label = '';
            let dateFormat = 'MMM. D, YYYY';

            if ($scope.filterData.filters.start_date) {
              label += moment($scope.filterData.filters.start_date).format(dateFormat);
            }

            if ($scope.filterData.filters.end_date) {
              if($scope.filterData.filters.start_date
                && !moment($scope.filterData.filters.start_date).isBefore(moment($scope.filterData.filters.end_date))) {
                alert("Start date filter must fall before selected end date.");
                $scope.filterData.filters.start_date = null;
              } else {
                if (label) {
                  label += ' - ';
                }
                label += moment($scope.filterData.filters.end_date).format(dateFormat);
              }
            }

            $scope.filterData.labels['date-1'] = label;
            break;
        }
      };

      $scope.getTeams = () => {
        let deferred = $q.defer();

        teamService.getByAccess({restrict_by_clips: true})
          .then(
            response => {
              let data = response.data;

              if (data.error) {
                alert(data.error);
                deferred.reject();
              } else {
                $scope.playerTeams = data;

                if( Array.isArray($scope.playerTeams) && $scope.playerTeams.length === 1) {
                  $scope.setFilterProperty('my_teams', $scope.playerTeams[0])
                }

                deferred.resolve();
              }
            }
          );

        return deferred.promise;
      };

      $scope.getTeamOpponents = () => {
        let team_ids = $scope.filterData.filters.my_teams;
        let options = {filter_by: 'my-clips'};

        if (team_ids) {
          options.teams = team_ids.toString()
        }

        teamService.getTeamsOpponents(options)
          .then(
            response => {
              let data = response.data;

              if (data.error) {
                alert(data.error);
                $scope.opponents = null;
              } else {
                $scope.opponents = {};
                if(Array.isArray(data) && data.length === 0) {
                  $scope.opponents['message'] = 'No Opponents Found';
                } else {
                  $scope.opponents = data;
                }
              }
            }
          );
      };

      $scope.getTeamPlayers = (group) => {
        let team_ids = $scope.filterData.filters.my_teams;
        let season_ids = $scope.filterData.filters.seasons;
        let options = {filter_by: 'my-clips'};

        switch (group) {
          case 'opponent_player':
            //team_ids = $scope.filterData.filters.opponents;
            options.player_type = 'opponent';
            $scope.opponentPlayers = null;
            break;
          case 'player':
            options.player_type = 'my-player';
            $scope.players = null;
            break;
        }

        if (team_ids) {
          options.teams = team_ids.toString();
        }

        if(season_ids) {
          options.season_ids = season_ids.toString();
        }

        teamService.getTeamsPlayers(options)
          .then(
            response => {
              let data = response.data;

              if (data.error) {
                alert(data.error);

                switch (group) {
                  case 'opponent_player':
                    $scope.opponentPlayers = null;
                    break;
                  case 'player':
                    $scope.players = null;
                    break;
                }
              } else {
                switch (group) {
                  case 'opponent_player':
                    $scope.opponentPlayers = {};
                    if(Array.isArray(data) && data.length === 0) {
                      $scope.opponentPlayers['message'] = 'No Players Found';
                    } else {
                      $scope.opponentPlayers = data;
                      angular.forEach($scope.opponentPlayers, function (player) {
                        player['playerbrief'] = player.jersey_number + ' ' + player.team_abbrev + ' ' + player.label + ' ' + player.season;
                      });
                    }
                    break;
                  case 'player':
                    $scope.players = {};
                    if(Array.isArray(data) && data.length === 0) {
                      $scope.players['message'] = 'No Players Found';
                    } else {
                      $scope.players = data;
                      angular.forEach($scope.players, function (player) {
                        player['playerbrief'] = player.jersey_number + ' ' + player.team_abbrev + ' ' + player.label + ' ' + player.season;
                      });
                    }
                    break;
                }
              }
            }
          );
      };

      $scope.getStrengths = () => {
        let options = {
          filter_by: 'my-clips'
        };

        let category_ids = Array.isArray($scope.filterData.filters.categories) &&  $scope.filterData.filters.categories.length
          ? $scope.filterData.filters.categories : null;

        let subcategory_ids = Array.isArray($scope.filterData.filters.subcategories) &&  $scope.filterData.filters.subcategories.length
          ? $scope.filterData.filters.subcategories : null;

        if(category_ids) {
          options.categories = category_ids.toString();
        }

        if(subcategory_ids) {
          options.subcategories = subcategory_ids.toString();
        }

        if (options.hasOwnProperty('categories') || options.hasOwnProperty('subcategories')) {
          clipCategoryService.getSubcategoryStrengths(options)
            .then(
              response => {
                let data = response.data;

                if (data.error) {
                  alert(data.error);
                  $scope.strengths = null;
                } else {
                  $scope.strengths = {};
                  if(Array.isArray(data) && data.length === 0) {
                    $scope.strengths['message'] = 'No Strengths Found';
                  } else {
                    $scope.strengths['list'] = data;
                  }
                }
              }
            );
        } else {
          $scope.strengths = null;
        }
      };

      $scope.createPreset = () => {
        clipFilterService.createFilter($scope.presetName, $scope.filterData.filters)
          .then(
            response => {
              let data = response.data;

              if (data.error) {
                alert(data.error);
              } else {
                getFilters(data);
                alert(`Filter preset '${data.name}' saved!`);
              }
            }
          );

        $scope.presetName = null;
        $scope.togglePresetForm(false);
      };

      $scope.updatePreset = () => {
        if ($scope.selectedPreset) {
          $scope.selectedPreset.filters = angular.copy($scope.filterData.filters);
          $scope.selectedPreset.labels = angular.copy($scope.filterData.labels);

          if($scope.selectedPreset.filters.hasOwnProperty('preset')) {
            delete $scope.selectedPreset.filters['preset'];
            delete $scope.selectedPreset.labels['preset'];
          }

          clipFilterService.updateFilter($scope.selectedPreset)
            .then(
              response => {
                let data = response.data;

                if (data.error) {
                  alert(data.error);
                } else {
                  alert(`Filter preset '${data.name}' updated!`);
                  $rootScope.$broadcast('update_preset_success', {canUpdatePresets: false});
                  getFilters();
                }
              }
            );
        }
      };

      $scope.deletePreset = () => {
        if ($scope.selectedPreset) {
          let r = confirm(`Are you sure you want to delete the quick filter '${$scope.selectedPreset.name}'?`);
          if (r === true) {
            clipFilterService.deleteFilter($scope.selectedPreset.id)
              .then(
                response => {
                  let data = response.data;

                  if (data.error) {
                    alert(data.error);
                  } else {
                    $scope.selectedPreset = null;
                    if($scope.filterData.filters.hasOwnProperty('preset')) {
                      delete $scope.filterData.filters['preset'];
                      delete $scope.filterData.labels['preset'];
                    }
                    getFilters();
                  }
                }
              );
          }
        }
      };

      $scope.cancelPreset = () => {
        $scope.presetName = null;
        $scope.togglePresetForm(false);
        //$scope.showPresetActions = false;
      };

      $scope.togglePresetForm = (toggleOn) => {
        if($scope.filterCount) {
          if (typeof toggleOn === 'undefined') {
            $scope.showPresetActions = !$scope.showPresetActions;
          } else {
            $scope.showPresetActions = toggleOn;
          }

          if($scope.selectedPreset) {
            $scope.selectedPreset = null;
          }
        }
      };

      let getFilters = (assignSelectedPreset) => {
        clipSearchService.retrieveFilters()
          .then(
            response => {
              let data = response.data;

              if (data.error) {
                alert(data.error);
              } else {
                if (data) {
                  $scope.presetFilters = data;

                  if (assignSelectedPreset) {
                    assignSelectedPreset = angular.isObject(assignSelectedPreset) ? assignSelectedPreset.id : assignSelectedPreset;
                    _.forEach($scope.presetFilters, (preset) => {
                      if (assignSelectedPreset === preset.id) {
                        $scope.selectedPreset = preset;
                      }
                    });
                  }
                } else {
                  $scope.presetFilters = {};
                }
              }
            }
          );
      };

      let init = () => {
        if($scope.filterData.filters.hasOwnProperty('preset')) {
          $scope.assignPresetFilters = false;
        }

        getFilters($scope.filterData.filters.hasOwnProperty('preset') ? $scope.filterData.filters.preset : null);

        clipCategoryService.getCategories({filter_by: 'my-clips'})
          .then(
            response => {
              let data = response.data;

              if (data.error) {
                alert(data.error);
              } else {
                $scope.categories = data;
              }
            }
          );

        clipCategoryService.getSubcategories({filter_by: 'my-clips'})
          .then(
            response => {
              let data = response.data;

              if (data.error) {
                alert(data.error);
              } else {
                $scope.subcategories = data;
              }
            }
          );

        if(dateService.seasonList.length) {
          dateService.clearList();
        }

        $scope.seasons = dateService.generateSeasonList(20, '2009-2010', 28);
        $scope.seasons.reverse();
        $scope.getTeams();
      };

      $scope.showPresetButtonSet = (setName) => {
        switch (setName) {
          case 'presetForm':
            return $scope.showPresetForm;
          case 'presetSelected':
            return !$scope.showPresetForm && $scope.selectedPreset && !$scope.deleteSelectedPreset;
          case 'deletePreset':
            return !$scope.showPresetForm && $scope.selectedPreset && $scope.deleteSelectedPreset;
          default:
            return !$scope.showPresetForm && !$scope.selectedPreset;
        }
      };

      $scope.buttonSetSize = () => {
        let x2 =
          $scope.showPresetButtonSet('presetForm')
          || $scope.showPresetButtonSet('presetSelected') || $scope.showPresetButtonSet('deletePreset');
        if (x2) {
          return '2x';
        } else {
          return '1x';
        }
      };

      $scope.$on('forward_filter_count', (event, data) => {
        $scope.filterCount = data.filterCount;
      });

      $scope.$on('forward_clip_count', (event, data) => {
        $scope.clipCount = data.clipCount;
        $scope.filterCount = data.filterCount;

        $scope.disableSelections = !$scope.clipCount && $scope.filterCount && !$scope.defaultValue;
      });

      $scope.$on('update_preset', () => {
        $scope.updatePreset();
      });

      $scope.$on('delete_preset', () => {
        $scope.deletePreset();
      });

      $scope.$on('clear_selected_preset', () => {
        $scope.selectedPreset = null;
      });

      $scope.$on('remove_player_opp_team', (event, data) => {
        let removed_player = $filter('filter')($scope.opponentPlayers.list, {id: data.player_id});
        let players = $filter('filter')($scope.opponentPlayers.list, {team_id: removed_player[0].team_id});
        let player_found = false;


        _.forEach( $scope.filterData.filters.opponent_players, (player_id) => {
          _.forEach(players, (player) => {
            if(player.id === player_id) {
              player_found = true;
            }
          });
        });

        let team_index = $scope.filterData.filters.opponent_player_teams.indexOf(removed_player[0].team_id);

        if(!player_found) {
          $scope.filterData.filters.opponent_player_teams.splice(team_index, 1);
        }
      });

      $scope.$watch(
        'selectedPreset',
        () => {
          if ($scope.filterData && $scope.selectedPreset && $scope.assignPresetFilters) {
            let tempFilter = {
              filters: {'preset': $scope.selectedPreset.id},
              labels: {'preset': $scope.customDataDisplay('preset', $scope.selectedPreset)}
            };

            tempFilter.filters =  _.merge(tempFilter.filters, $scope.selectedPreset.filters);
            tempFilter.labels =  _.merge(tempFilter.labels, $scope.selectedPreset.labels);

            $scope.filterData.filters = tempFilter.filters;
            $scope.filterData.labels = tempFilter.labels;
          }

          if($scope.selectedPreset) {

            if(!$scope.assignPresetFilters) {
              $scope.assignPresetFilters = true;
            }
          } else {
            if($scope.filterData.filters.hasOwnProperty('preset'))
              delete $scope.filterData.filters.preset;
            delete $scope.filterData.labels.preset;
          }
        }
      );

      /*$scope.$watch(
        () => {
          return $scope.filterData.filters.opponents;
        },
        () => {
          $scope.getTeamPlayers('opponent_player');
        },
        true
      );*/

      $scope.$watch(
        () => {
          return $scope.filterData.filters.my_teams;
        },
        () => {
          $scope.getTeamOpponents();

          if(angular.isDefined($scope.filterData.filters.my_teams) && $scope.filterData.filters.my_teams !== null && $scope.filterData.filters.my_teams.length) {
            $scope.getTeamPlayers('player');
            $scope.getTeamPlayers('opponent_player');
          } else {
            $scope.players = null;
            $scope.opponentPlayers = null;
          }
        },
        true
      );

      $scope.$watch(
        () => {
          return $scope.filterData.filters.seasons;
        },
        () => {

          if(angular.isDefined($scope.filterData.filters.my_teams) && $scope.filterData.filters.my_teams !== null && $scope.filterData.filters.my_teams.length) {
              $scope.getTeamPlayers('player');
              $scope.getTeamPlayers('opponent_player');
          }
        },
        true
      );

      $scope.$watch(
        () => {
          return $scope.filterData.filters.categories;
        },
        () => {

          if(angular.isDefined($scope.filterData.filters.categories) && $scope.filterData.filters.categories !== null && $scope.filterData.filters.categories.length) {
            $scope.getStrengths()
          } else {
            $scope.strengths = null;
          }
        },
        true
      );

      $scope.$watch(
        () => {
          return $scope.filterData.filters.subcategories;
        },
        () => {

          if(angular.isDefined($scope.filterData.filters.subcategories) && $scope.filterData.filters.subcategories !== null && $scope.filterData.filters.subcategories.length) {
            $scope.getStrengths()
          } else {
            $scope.strengths = null;
          }
        },
        true
      );

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/clipSearch/filterFormDirective/filterFormController.js